export default "__VITE_ASSET__CYJK$KPN__"